import * as Sentry from "@sentry/browser";

import { isUnexpectedSystemError } from "./isUnexpectedSystemError";

/**
 * Reports an unexpected system error to the monitoring pipeline (`console.error`
 * for Datadog RUM auto-capture plus Sentry). Errors classified by the backend as
 * user-facing (e.g. {@link FetchUserEncodedError}, {@link FetchUserError}) are
 * skipped — they are already surfaced to the user via toast or modal, and
 * reporting them inflates monitoring with non-actionable events.
 *
 * Use this in catch blocks in place of bare `console.error(...)` +
 * `Sentry.captureException(...)` when the intent is "log this if it represents
 * an actual bug or system failure".
 *
 * @param error The caught value. Non-Error values and all non-Fetch errors are
 *   treated as unexpected and reported, preserving signal for genuine bugs.
 * @param context A short human-readable description prepended to the console
 *   message (e.g. `"Error sending test message:"`).
 */
export function reportUnexpectedError(error: unknown, context: string): void {
  if (!isUnexpectedSystemError(error)) {
    return;
  }
  console.error(context, error);
  Sentry.captureException(error);
}
